interface Props {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export default function GlassCard({ children, className = '', id }: Props) {
  return (
    <div
      id={id}
      className={`bg-white/80 backdrop-blur-sm border border-cream-200 rounded-2xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 ${className}`}
    >
      {children}
    </div>
  );
}
